import React from "react"
import { withRadium, DetectCompact } from "higher-order-components"
import { HeadingBlock } from "containers"
import COLOR_PALETTE from "constants/color-palette"

const HeadingVideoFrame = ({
  preHeadingTagOverride,
  tagOverride,
  mobilePreHeading,
  mobileHeading,
  preHeading,
  heading,
  compact,
  children
}) => (
  <div style={styles.wrapper}>
    <HeadingBlock
      preHeadingTagOverride={preHeadingTagOverride}
      tagOverride={tagOverride}
      preHeading={mobilePreHeading && compact ? mobilePreHeading : preHeading}
      value={compact ? mobileHeading : heading}
      tag="h1"
      feature
      margin/>
    <div style={styles.componentArea}>{children}</div>
  </div>
)

const styles = {
  wrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    textAlign: "center",
    color: COLOR_PALETTE.WHITE
  },
  componentArea: {
    marginBottom: "2em"
  }
}

export default withRadium(DetectCompact())(HeadingVideoFrame)



// WEBPACK FOOTER //
// ./src/components/heading-video-frame/index.jsx